import React from 'react';

const Header = props => (
    <header className="header-section" id="header-section">
        <div className="container">
            <h1 className="pb-3 pt-4 text-center text-lg-left site-title">
            <img src="/assets/images/worldcup2018/worldcup-logo.png" alt="2018 FIFA WORLD CUP RUSSIA LOGO" className="site-logo" style={{ width: '300px' }}/>
            <span className="d-inline-block mt-3 ml-3 sr-only">2018 FIFA WORLD CUP RUSSIA™
                <small className="d-block site-sub-title">14 JUNE - 15 JULY</small>
            </span>
            </h1>
        </div>

        {props.children}

        <figure className="ads-banner mb-0 py-4">
            <img src="/assets/images/worldcup2018/ads.png" className="d-none d-lg-block mx-auto" />
            <img src="/assets/images/worldcup2018/ad_uefa.jpg" className="d-block d-lg-none mx-auto"/>
        </figure>
    </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js